import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence } from
"firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const defaultConfig = {
  apiKey: "AIzaSyD7qcvVA_7W1HlRPNSiM0laoMxFTJ1jCMc",
  authDomain: "futuredocuments.firebaseapp.com",
  projectId: "futuredocuments",
  storageBucket: "futuredocuments.firebasestorage.app",
  messagingSenderId: "955891124543",
  appId: "1:955891124543:web:c4f3d9e6c4947b67af6b8a",
  measurementId: "G-2EVTWMH5F2"
};

// REACT_APP_FIREBASE_CONFIG (JSON) points a build at another project, e.g. the
// EU project after the 4.8 migration; it is baked in at build time.
function resolveConfig() {
  const raw = process.env.REACT_APP_FIREBASE_CONFIG;
  if (!raw) return defaultConfig;
  try {
    return { ...defaultConfig, ...JSON.parse(raw) };
  } catch {
    console.error("REACT_APP_FIREBASE_CONFIG is not valid JSON; using the default project.");
    return defaultConfig;
  }
}

const firebaseConfig = resolveConfig();

const SECONDARY_APP_NAME = "SecondaryAuthApp";

let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(() => {});

const db = getFirestore(app);
const storage = getStorage(app);

/** Secondary Auth app — create users without signing out the current admin session */
export function getSecondaryAuth() {
  const existing = getApps().find((a) => a.name === SECONDARY_APP_NAME);
  const secondaryApp = existing || initializeApp(firebaseConfig, SECONDARY_APP_NAME);
  return getAuth(secondaryApp);
}

export { app, auth, db, storage, firebaseConfig };
export default app;
